import React from 'react';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { IconButtonV2 } from 'components/common/ui';
import { formatDate } from '@utils';

import styles from './attachmentList.style';

const AttachmentList = ({ attachments, disabled, onDelete }) => {
  const handleRemoveAttachment = (attachment) => {
    onDelete(attachment);
  };

  if (!attachments || attachments.length === 0) {
    return null;
  }

  const handlePreview = (attachment) => {
    if (attachment.url) {
      window.open(attachment.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Box sx={styles.attachmentsWrapper}>
      <Box sx={styles.attachmentsTitle}>Attachments ({attachments.length})</Box>
      <Box sx={styles.attachmentsList}>
        {attachments.map((attachment) => (
          <Box
            key={attachment.id}
            sx={{
              ...styles.attachmentItem,
              cursor: attachment.url ? 'pointer' : 'default',
            }}
            onClick={() => handlePreview(attachment)}
          >
            <AttachFileIcon sx={styles.attachmentIcon} />
            <Box sx={styles.attachmentName}>
              {attachment.name || attachment.filename}
              {attachment.createdAt && (
                <small>
                  Uploaded At: {formatDate(attachment.createdAt, 'dd/MM/yyyy')}
                </small>
              )}
              {attachment.size && (
                <small>Size: {(attachment.size / 1024).toFixed(2)} KB</small>
              )}
            </Box>
            {onDelete && (
              <IconButtonV2
                variant="text"
                disabled={disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveAttachment(attachment);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButtonV2>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AttachmentList;
